import { useEffect, useState } from "react";
import { Settings, Shield, User as UserCheck } from "react-feather";
import { useSelector } from "react-redux";
import AccountHeader from "../../../components/layout/accounts-header/account-header";
import { trackingEventDictionary } from "../../../core/dictionary/track-events";
import { generateTrackingObject, trademoTrackingEvents } from "../../../core/utility/trademo-tracking";
import "../accounts.scss";
import CrmIntegration from "./details/crm-integration";
import ProfileDetails from "./details/profile-details-default";
import SecurityDetails from "./details/security-details-default";
import SecurityDetailsEdit from "./details/security-details-edit";
import SecurityDetailsModified from "./details/security-details-modified";

export default function User({ location }) {
  const { profile: userDetails } = useSelector((state) => state.user);

  const [securityMode, setSecurityMode] = useState(true);
  const [modifiedMode, setModifiedMode] = useState(true);
  const [showConfigTab, setShowConfigTab] = useState(false);
  const [isAdminAccount, setIsAdminAccount] = useState(false);

  const toggleSecurity = () => setSecurityMode((prev) => !prev);
  const toggleModified = () => setModifiedMode((prev) => !prev);

  const openSecurity = () => {
    trademoTrackingEvents(trackingEventDictionary.headerUserProfileProfileDetailsSecurity, generateTrackingObject());
    setSecurityMode(true);
    setModifiedMode(true);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const path = location.pathname;

    if ((path.includes("/salesforce-status") || path.includes("/hubspot-status") || path.includes("/zoho-status")) && params.get("code")) {
      setShowConfigTab(true);
    }
  }, [location]);

  useEffect(() => {
    if (userDetails && userDetails.isAdmin) {
      setIsAdminAccount(true);
    }
  }, [userDetails]);

  return (
    <div>
      <AccountHeader />
      <div className="accounts-container">
        <div className="row no-gutters" data-widget="tab-slider">
          <div className="col-2 border-vertical tw-pt-4 fold-grey">
            <div className="nav flex-column nav-pills">
              <a className={`!tw-flex ${showConfigTab ? "nav-link" : "nav-link active"}`} data-toggle="pill" href="#profile-tab">
                <UserCheck style={{ marginRight: 10 }} />
                My Profile
              </a>

              <a className="nav-link !tw-flex" data-toggle="pill" href="#security-tab" onClick={openSecurity}>
                <Shield style={{ marginRight: 10 }} />
                Security
              </a>

              {isAdminAccount && (
                <a className={`!tw-flex ${showConfigTab ? "nav-link active" : "nav-link"}`} data-toggle="pill" href="#config-tab">
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" width="24" viewBox="0 -960 960 960" fill="currentColor" style={{ marginRight: 10 }}>
                    <path d="m234-480-12-60q-12-5-22.5-10.5T178-564l-58 18-40-68 46-40q-2-13-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T222-820l12-60h80l12 60q12 5 22.5 10.5T370-796l58-18 40 68-46 40q2 13 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T326-540l-12 60h-80Zm40-120q33 0 56.5-23.5T354-680q0-33-23.5-56.5T274-760q-33 0-56.5 23.5T194-680q0 33 23.5 56.5T274-600ZM592-40l-18-84q-17-6-31.5-14.5T514-158l-80 26-56-96 64-56q-2-18-2-36t2-36l-64-56 56-96 80 26q14-11 28.5-19.5T574-516l18-84h112l18 84q17 6 31.5 14.5T782-482l80-26 56 96-64 56q2 18 2 36t-2 36l64 56-56 96-80-26q-14 11-28.5 19.5T722-124l-18 84H592Zm56-160q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z" />
                  </svg>
                  Configuration
                </a>
              )}
            </div>
          </div>

          <div className="col-10 fold-grey">
            <div className="tab-content">
              <div className={`${showConfigTab ? "tab-pane fade" : "tab-pane fade show active"}`} id="profile-tab">
                <ProfileDetails userDetails={userDetails} />
              </div>

              <div className="tab-pane fade" id="security-tab">
                {securityMode ? (
                  <SecurityDetails togglefunc1={toggleSecurity} />
                ) : modifiedMode ? (
                  <SecurityDetailsEdit togglefunc1={toggleSecurity} togglefunc2={toggleModified} userDetails={userDetails} />
                ) : (
                  <SecurityDetailsModified togglefunc2={toggleModified} />
                )}
              </div>

              <div className={`${showConfigTab ? "tab-pane fade show active" : "tab-pane fade"}`} id="config-tab">
                <CrmIntegration userDetails={userDetails} location={location} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-sticky-bottom py-2">
        <small>©Trademo Technologies Inc.</small>
      </div>
    </div>
  );
}
